// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_MOD_INST_CONF, SUC_MOD_INST_CONF } from '../../../../utils/strings';

const useArchiveAndCreateInstrumentConfiguration = () => {
  const { submit } = useExerciseSubmission(
    RegistrarService.RegistrarService_ArchiveAndCreateInstrumentConfiguration,
    SUC_MOD_INST_CONF,
    ERR_MOD_INST_CONF,
  );

  return submit;
};

export default useArchiveAndCreateInstrumentConfiguration;
